module.exports = __webpack_public_path__ + "7e038c18ab0e4e2669fc678b5d3183c3.glb";